
export type GetMetricsSummary401 = {
  error?: string;
};
